import { useMemo, useRef } from 'react';
import hasClass from 'dom-helpers/hasClass';
import { useBootstrapPrefix } from './ThemeProvider';
import Popover from './Popover'; // This is meant for internal use.
// This applies a custom offset to the overlay if it's a popover.

export default function useOverlayOffset(customOffset) {
  var overlayRef = useRef(null);
  var popoverClass = useBootstrapPrefix(undefined, 'popover');
  var offset = useMemo(function () {
    return {
      name: 'offset',
      options: {
        offset: function offset() {
          if (overlayRef.current && hasClass(overlayRef.current, popoverClass)) {
            return customOffset || Popover.POPPER_OFFSET;
          }
          return customOffset || [0, 0];
        }
      }
    };
  }, [customOffset, popoverClass]);
  return [overlayRef, [offset]];
}